import axios from "axios";
import {
  getSubjectsFailure,
  getSubjectsStart,
  getSubjectsSuccess,
} from "./SubjectsActions";

export const getSubjects = async (user, dispatch) => {
  dispatch(getSubjectsStart());

  try {
    let url = "/api/subject/all";
    const params = new URLSearchParams();

    // If user is not admin and not ALL, scope to their course/semester
    if (user && !user.isAdmin && user.course !== "ALL") {
      if (user.course) params.append("course", user.course);
      if (user.semester) params.append("sem", user.semester);
    }

    const fullUrl = params.toString() ? `${url}?${params.toString()}` : url;

    let res = await axios.get(fullUrl, {
      headers: {
        token: "Bearer " + user.accessToken,
      },
    });

    // Fallback: if filtered returns empty, fetch all
    if (!Array.isArray(res.data) || res.data.length === 0) {
      res = await axios.get(url, {
        headers: { token: "Bearer " + user.accessToken },
      });
    }

    dispatch(getSubjectsSuccess(res.data));
  } catch (err) {
    dispatch(getSubjectsFailure(err));
  }
};
